module.exports = __webpack_public_path__ + "img/minus.a88d50bf.svg";